export const loginConstant = {
  mobile: {
    en: "Enter Phone Number",
    hi: "फ़ोन नंबर डालें",
    or: "ଫୋନ୍ ନମ୍ବର ଦିଅନ୍ତୁ",
  },
  pass: {
    en: "Enter the 6 digit OTP",
    hi: "6-डिजिट ओटीपी दर्ज करें",
    or: "6 ଅଙ୍କ ବିଶିଷ୍ଟ OTP",
  },
  support:{
    en:"Call for Support",
    hi:"सहायता के लिए कॉल करें"
  },
  proceedButton:{
    en:"Verify",
    hi:"आगे बढ़ें",
    or: "ଆଗକୁ ବଢ଼ନ୍ତୁ"
  },
  verifying: {
    en: "Verifying...",
    hi: "जांच हो रही है...",
    or: "ଯାଞ୍ଚିତ କରିବା ହାରାଇଛି..."
  },
  otpTitle: {
    en: "Enter 6 digit HealthVaani code",
    hi: "6 अंकों का HealthVaani कोड दर्ज करें।",
    or: "6 ଅଙ୍କିଆ HealthVaani କୋଡ୍ ଦିଅନ୍ତୁ"
  },
  resendOtp: {
    en: "Send OTP Again",
    hi: "फिर से ओटीपी भेजें"
  }
};

export const getOtpSentLabel = {
  first: {
    en: "Code sent via SMS to ",
    hi: "कोड ",
    or: "କୋଡ୍‌ଟି SMS ଦ୍ୱାରା ",
  },
  second: {
    en: "",
    hi: " पर मैसेज कर दिया है",
    or: " କୁ ପଠାଯାଇଛି",
  }
}

export const loginErrorMap = {
  username: "User not found.",
  otp: "Incorrect OTP"
}

export const loginErrorLabels = {
  username:{
    en:"Please re-check your mobile number",
    hi:"कृपया अपना मोबाइल नंबर फिर से जांच लें",
    or: "ଆପଣଙ୍କର ମୋବାଇଲ ନମ୍ବର ପରିପ୍ରକ୍ଷେପରେ ପଠାନ୍ତୁ।"
    },
  otp: {
    en:"Incorrect OTP",
    hi:"गलत ओटीपी",
    or: "ଗଲତ OTP"
  }
}
export const loginAudio = {
  en:"Type the OTP received in your registered mobile number.",
  hi:"अपने रजिस्टर्ड मोबाइल नंबर पर प्राप्त ओटीपी टाइप करें।",
  or: "ଆପଣଙ୍କର ରଜିଷ୍ଟର୍ଡ ମୋବାଇଲ ନମ୍ବର ପରିପ୍ରକ୍ଷେପରେ ପଠାନ୍ତୁ।"
}

export const logoutText = {
  confirmation : {
    en:"Do you want to Logout?",
    hi:"क्या आप लॉगआउट करना चाहते हैं?",
    or: "ଆପଣ କ'ଣ ଲଗଆଉଟ୍ କରିବାକୁ ଚାହୁଁଛନ୍ତି?",
  },
  yes:{
    en:"Yes, Log Out",
    hi:"हाँ, लॉगआउट",
    or: "ହଁ, ଲଗଆଉଟ୍"
  },
  no:{
    en:"No, Go back",
    hi:"नहीं, चेट पर लौटें",
    or: "ନା, ଫେରି ଯାଆନ୍ତୁ"
  }
}
export const resendOtpTimer = {
  first: {
    en: "Resend Code in ",
    hi: "कोड दोबारा भेजें",
    or: "",
  },
  second: {
    en: " sec",
    hi: " sec",
    or: " sec ପୁନଃ କୋଡ୍ ପଠାନ୍ତୁ"
  }
}

export const resendOtpConstants = {
  first: {
    en: "Didn’t receive code?",
    hi: "कोड प्राप्त नहीं हुआ?",
    or: "କୋଡ୍ ମିଳିଲା ନାହିଁ?",
  },
  second: {
    en: "Resend",
    hi: "दोबारा भेजें",
    or: "ପୁନିଥରେ ପଠାନ୍ତୁ",
  }
}
export const verifyingCaptcha = {
  en:"Verifying you are human...",
  hi:"आप एक मनुष्य हैं की जांच कर रहा है...",
  or: "ଆପଣ ଏକ ମାନୁଷଙ୍କ ହେଉଛନ୍ତି କିନ୍ତୁ ନାହିଁ କିନ୍ତୁ ନାହିଁ"
}